import { cx } from "class-variance-authority";

interface PrivacyPolicyTermsOfServiceFooterProps {
  textClassName?: string;
}
export const PrivacyPolicyTermsOfServiceFooter = (
  props: PrivacyPolicyTermsOfServiceFooterProps,
) => {
  return (
    <p
      id="privacyPolicyTermsOfServiceFooter"
      className={cx("font-inter text-medium-hippo", "text-center text-sm")}
    >
      By continuing, you acknowledge that you agree to the{" "}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://start.florecruit.com/terms-of-service"
        className={cx("text-navy", "underline")}
      >
        Terms of Service
      </a>{" "}
      and{" "}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://start.florecruit.com/privacy-policy"
        className={cx("text-navy", "underline")}
      >
        Privacy Policy
      </a>{" "}
      and provide consent under the{" "}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://start.florecruit.com/privacy-policy"
        className={cx("text-navy", "underline")}
      >
        Privacy Policy
      </a>
      .
    </p>
  );
};
